import getConfig from 'next/config'

export const AMPLITUDE_API_KEY = runtimeEnv('AMPLITUDE_API_KEY')
export const API_MOCKING = runtimeEnv('API_MOCKING')
export const APP_ENV = runtimeEnv('APP_ENV')
export const APP_VERSION = runtimeEnv('APP_VERSION')
export const BANKING_API_ENDPOINT = runtimeEnv('BANKING_API_ENDPOINT')
export const BANKING_API_ENDPOINT_V2 = runtimeEnv('BANKING_API_ENDPOINT_V2')
export const BANKING_API_ENDPOINT_V3 = runtimeEnv('BANKING_API_ENDPOINT_V3')
export const BFF_API_BANKING_ENDPOINT = runtimeEnv('BFF_API_BANKING_ENDPOINT')
export const BFF_HOME_API_ENDPOINT_V2 = runtimeEnv('BFF_HOME_API_ENDPOINT_V2')
export const BFF_HOME_API_ENDPOINT_V3 = runtimeEnv('BFF_HOME_API_ENDPOINT_V3')
export const ENGAGEMENT_API_ENDPOINT = runtimeEnv('ENGAGEMENT_API_ENDPOINT')
export const ENGAGEMENT_API_ENDPOINT_V3 = runtimeEnv('ENGAGEMENT_API_ENDPOINT_V3')
export const CARDS_BFF_CARDS_GENESIS_API_ENDPOINT = runtimeEnv('CARDS_BFF_CARDS_GENESIS_API_ENDPOINT')
export const CARDS_BFF_CREDIT_CARD_LIMITS_API_ENDPOINT = runtimeEnv('CARDS_BFF_CREDIT_CARD_LIMITS_API_ENDPOINT')
export const CREDIT_API_ENDPOINT = runtimeEnv('CREDIT_API_ENDPOINT')
export const CREDIT_INSURANCE_API_ENDPOINT = runtimeEnv('CREDIT_INSURANCE_API_ENDPOINT')
export const CUSTOMER_API_ENDPOINT = runtimeEnv('CUSTOMER_API_ENDPOINT')
export const CUSTOMER_API_ENDPOINT_V1 = runtimeEnv('CUSTOMER_API_ENDPOINT_V1')
export const DATADOG_APPLICATION_ID = runtimeEnv('DATADOG_APPLICATION_ID')
export const DATADOG_CLIENT_TOKEN = runtimeEnv('DATADOG_CLIENT_TOKEN')
export const DEPLOY_TYPE = runtimeEnv('DEPLOY_TYPE')
export const DEV_TOOLS = runtimeEnv('DEV_TOOLS')
export const DUNNING_API_ENDPOINT = runtimeEnv('DUNNING_API_ENDPOINT')
export const EXPERIMENT_API_KEY = runtimeEnv('EXPERIMENT_API_KEY')
export const HOTJAR_ID = runtimeEnv('HOTJAR_ID')
export const INSURANCE_BFF_API_ENDPOINT = runtimeEnv('INSURANCE_BFF_API_ENDPOINT')
export const INSURANCE_FILES_API_ENDPOINT = runtimeEnv('INSURANCE_FILES_API_ENDPOINT')
export const LOG_API_TOKEN = runtimeEnv('LOG_API_TOKEN')
export const LUCY_API_BASE_URL = runtimeEnv('LUCY_API_BASE_URL')
export const NODE_ENV = runtimeEnv('NODE_ENV')
export const ONBOARDING_TEAMS_API_ENDPOINT_V1 = runtimeEnv('ONBOARDING_TEAMS_API_ENDPOINT_V1')
export const ONBOARDING_TEAMS_API_ENDPOINT_V2 = runtimeEnv('ONBOARDING_TEAMS_API_ENDPOINT_V2')
export const OPEN_FINANCE_API_ENDPOINT = runtimeEnv('OPEN_FINANCE_API_ENDPOINT')
export const PAGAR_ME_API_ENDPOINT = runtimeEnv('PAGAR_ME_API_ENDPOINT')
export const PAGAR_ME_BIN_API_ENDPOINT = runtimeEnv('PAGAR_ME_BIN_API_ENDPOINT')
export const PAYMENT_LINK_HUB_ENDPOINT = runtimeEnv('PAYMENT_LINK_HUB_ENDPOINT')
export const PAYMENTS_API_GATEWAY = runtimeEnv('PAYMENTS_API_GATEWAY')
export const PAYMENTS_RECEIVABLES_BFF = runtimeEnv('PAYMENTS_RECEIVABLES_BFF')
export const PAYMENTS_RECEIVABLES_BFF_V2 = runtimeEnv('PAYMENTS_RECEIVABLES_BFF_V2')
export const PAYMENTS_RECEIVABLES_APP_BFF = runtimeEnv('PAYMENTS_RECEIVABLES_APP_BFF')
export const PORTAL_API_ENDPOINT = runtimeEnv('PORTAL_API_ENDPOINT')
export const PORTS__TWILIO__CUSTOM_API_ENDPOINT = runtimeEnv('PORTS__TWILIO__CUSTOM_API_ENDPOINT')
export const PUBLIC_GOOGLE_ANALYTICS = runtimeEnv('PUBLIC_GOOGLE_ANALYTICS')
export const RAV_API_ENDPOINT = runtimeEnv('RAV_API_ENDPOINT')
export const RAV_SPOT_ONE_STONE_API_ENDPOINT = runtimeEnv('RAV_SPOT_ONE_STONE_API_ENDPOINT')
export const RECAPTCHA_SITE_KEY = runtimeEnv('RECAPTCHA_SITE_KEY')
export const RECAPTCHA_PIX_SITE_KEY_ACCOUNT_PERSONAL = runtimeEnv('RECAPTCHA_PIX_SITE_KEY_ACCOUNT_PERSONAL')
export const RECAPTCHA_PIX_SITE_KEY = runtimeEnv('RECAPTCHA_PIX_SITE_KEY')
export const RECAPTCHA_PIX_BATCH_MANUAL_SITE_KEY = runtimeEnv('RECAPTCHA_PIX_BATCH_MANUAL_SITE_KEY')
export const RECAPTCHA_PIX_BATCH_FILE_SITE_KEY = runtimeEnv('RECAPTCHA_PIX_BATCH_FILE_SITE_KEY')
export const RECAPTCHA_PAYROLL_SITE_KEY = runtimeEnv('RECAPTCHA_PAYROLL_SITE_KEY')
export const SALES_SECTION_API_ENDPOINT = runtimeEnv('SALES_SECTION_API_ENDPOINT')
export const SHORT_SPOT_BASE_URL = runtimeEnv('SHORT_SPOT_BASE_URL')
export const SWH_API_ENDPOINT = runtimeEnv('SWH_API_ENDPOINT')
export const SWH_DEV_DOCUMENT = runtimeEnv('SWH_DEV_DOCUMENT')
export const SWH_MODE = runtimeEnv('SWH_MODE')
export const TWILIO__ACCOUNT_S_ID = runtimeEnv('TWILIO__ACCOUNT_S_ID')
export const TWILIO__FLEX_FLOW_S_ID = runtimeEnv('TWILIO__FLEX_FLOW_S_ID')
export const PRICING_API = runtimeEnv('PRICING_API')
export const ALWAYS_REFRESH_SESSION = runtimeEnv('ALWAYS_REFRESH_SESSION')
export const PAYMENTS_WEB_BFF = runtimeEnv('PAYMENTS_WEB_BFF')
export const INCOGNIA_APP_ID = runtimeEnv('INCOGNIA_APP_ID')
export const VENDAS_CORE_BFF_ENDPOINT = runtimeEnv('VENDAS_CORE_BFF_ENDPOINT')
export const TIME_TO_EXPIRE_TOKEN = 86400 // 24h em segundos
export const ENABLE_MOCKOON_PROXY = runtimeEnv('ENABLE_MOCKOON_PROXY')
export const BFF_ONBOARDING = runtimeEnv('BFF_ONBOARDING')
export const SESSION_MANAGER_API_ENDPOINT = runtimeEnv('SESSION_MANAGER_API_ENDPOINT')
export const TEAMS_API_ENDPOINT = runtimeEnv('TEAMS_API_ENDPOINT')

function runtimeEnv(key: string): () => string {
  return () => {
    let source = {} as NodeJS.ProcessEnv

    if (typeof window === 'undefined' || process?.env?.NODE_ENV === 'test') {
      source = getConfig().serverRuntimeConfig
    } else {
      source = getConfig().publicRuntimeConfig
    }

    return source[key] as string
  }
}

export { runtimeEnv }
